module.exports = __webpack_public_path__ + "static/img/teacher-back.e5853703.gif";